import { useState } from "react";

// import axios from 'axios'
import { useDispatch, useSelector } from "react-redux"
import marvarApi from "../../../../api/marvarApi"
import { onLogout } from "store"

import { useHelpers } from './useHelpers';
import { useGlobalStates } from './useGlobalStates';
import { useDefaultData } from './useDefaultData';
import { useForm } from './useForm';
import * as useFetchData from './useFetchData';
import { useActions } from './useActions';

export const useFetchInitCalendar = ({location, paramsURL}) => {

  const dispatch = useDispatch()

  const Helpers = useHelpers()

  const { user } = useSelector((state) => state.auth)

  // globalStates -------------------------------------------------------------------------------
  const globalStates = useGlobalStates()

  // defaultData --------------------------------------------------------------------------------
  const defaultData = useDefaultData({Helpers})

  // Para la modal -------------------------------------------------------
  const { defaultDataModal } = defaultData
  const [ dataModal, setDataModal ] = useState(defaultDataModal)
  const toggleOpen = (_, title, compont, dataRequest) => {
    setDataModal({
      ...defaultDataModal,
      open: !dataModal.open,
      titleModal: title,
      componentModal: compont,
      dataRequest: dataRequest
    })
  }
  const toggleClose = () => {
    setDataModal((prev) => ({
      ...prev,
      open: false
    }))
  }

  const FormScreen = useForm(defaultData.defaultFormScreen)

  const Forms = {
    FormScreen
  }

  const defaultFetchParams = { 
    //------------- Generales
    marvarApi, user, dispatch, onLogout, location, paramsURL,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms 
  }

  const fetchAllEvents = useFetchData.useFetchAllEvents({...defaultFetchParams})
  const fetchAInfoEvent = useFetchData.useFetchInfoEvent({...defaultFetchParams})

  const FetchData = {
    fetchAllEvents,
    fetchAInfoEvent,
  }

  const Actions = useActions({
    //------------- Generales
    marvarApi, user, dispatch, onLogout, location, paramsURL, toggleOpen, toggleClose,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
  })


  return Object.freeze({
    //------------- Generales
    dataModal, toggleOpen, toggleClose, location, paramsURL,
    //------------- globalStates
    globalStates,
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData,
    //------------- Actions
    Actions
  })

}
